<template>
  <div>
    <a-row style="margin-top: 0" :gutter="[24, 24]">
      <summary-statistics></summary-statistics>
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-value-container></chart-value-container>
      </a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-profit-container></chart-profit-container>
      </a-col>

      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-top-product-container-daily></chart-top-product-container-daily>
      </a-col>

      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <chart-top-product-container></chart-top-product-container>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ChartProfitContainer from "./chart/transaction/chart-profit-container";
import ChartValueContainer from "./chart/transaction/chart-value-container";
import SummaryStatistics from "./chart/transaction/summary-statistics";
import ChartTopProductContainer from "./chart/product/chart-top-product-container";
import ChartTopClientContainer from "./chart/client/chart-top-client-container";
import ChartTopBillerContainer from "./chart/biller/chart-top-biller-container";
export default {
  name: "admin-dashboard",
  components: {
    ChartTopBillerContainer,
    ChartTopClientContainer,
    ChartTopProductContainer, SummaryStatistics, ChartValueContainer, ChartProfitContainer},
}
</script>

<style scoped>

</style>
